import React from 'react';
import { useTranslation } from 'react-i18next';

const BRAND = 'VolleyStatsPro';

export interface PageTitleProps {
  /** Clé sous `common:page_titles.*` (ex. `dashboard`). */
  titleKey: string;
  children?: React.ReactNode;
}

/**
 * Pose le `<title>` du document pour un écran de route.
 *
 * React 19 hisse nativement les balises `<title>` rendues n'importe où dans
 * l'arbre : pas de hook ni de librairie, c'est la même convention que les
 * écrans publics qui écrivent leur `<title>` en dur (`PricingScreen`,
 * `LandingScreen`, …). Les écrans qui portent déjà leur propre balise ne
 * doivent pas être enveloppés ici, sinon deux titres coexistent.
 */
export const PageTitle: React.FC<PageTitleProps> = ({ titleKey, children }) => {
  const { t } = useTranslation('common');
  const label = t(`page_titles.${titleKey}`);

  return (
    <>
      <title>{`${label} — ${BRAND}`}</title>
      {children}
    </>
  );
};
